import { FormTemplate } from 'data/template/template.types';

const targetDeliveryRibbonC20CSCTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Ribbon C20 CSC',
  key: 'RIBBONC20_CSC',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['name', 'afType', 'afId'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        initial: '',
        hide: 'true',
      },
      name: {
        label: 'Template Name',
        type: 'text',
        validation: {
          required: true,
          validators: [
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
            {
              type: 'length',
              length: 32,
              errorMessage: 'Exceeds maximum length, 32.  Please re-enter.',
            },
          ],
        },
      },
      afType: {
        label: 'AF Type',
        type: 'select',
        initial: '',
        options: [],
        validation: {
          required: true,
        },
      },
      afId: {
        label: 'Access Function Name',
        type: 'select',
        initial: '',
        options: [
          {
            label: 'Select an Accesss Function',
            value: '',
          },
        ],
        validation: {
          required: true,
        },
      },
    },
  },
  usnbdTargetInformation: {
    metadata: {
      layout: {
        rows: [
          [
            'agencyid',
            'cdcid',
            '$empty',
          ],
        ],
      },
    },
    fields: {
      agencyid: {
        type: 'select',
        label: 'Agency ID',
        initial: '1',
        options: [
          {
            label: '1',
            value: '1',
          },
        ],
        validation: {
          required: true,
        },
      },
      cdcid: {
        type: 'select',
        label: 'CDC ID',
        initial: '1',
        options: [
          {
            label: '1',
            value: '1',
          },
        ],
        validation: {
          required: true,
        },
      },
    },
  },
  usnbdCallContentChannelInformation: {
    metadata: {
      layout: {
        rows: [
          [
            'cccid'
          ],
          [
            'definition',
            'ccraccess',
            'dnsrc'
          ],
          [
            'dndest',
            '$empty',
            '$empty'
          ],
        ],
      },
    },
    fields: {
      cccid: {
        type: 'text',
        hide: 'true',
        initial: ''
      },
      definition: {
        type: 'select',
        label: 'Definition',
        initial: 'PAIRED',
        options: [
          {
            label: 'PAIRED',
            value: 'PAIRED',
          },
          {
            label: 'COMBINED',
            value: 'COMBINED',
          }
        ],
        validation: {
          required: true,
        },
      },
      ccraccess: {
        type: 'select',
        label: 'CCR Access',
        initial: 'SW',
        options: [
          {
            label: 'SW',
            value: 'SW',
          },
          {
            label: 'DE',
            value: 'DE',
          }
        ],
        validation: {
          required: true,
        },
      },
      dnsrc: {
        type: 'text',
        label: 'Subject\'s DN',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 30,
              errorMessage: 'Exceeds maximum length, 30.  Please re-enter.',
            },
          ],
        },
      },
      dndest: {
        type: 'text',
        label: 'Associate\'s DN',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 30,
              errorMessage: 'Exceeds maximum length, 30.  Please re-enter.',
            },
          ],
        },
      },
    },
  }
};

export default targetDeliveryRibbonC20CSCTemplate;
